module.exports = __webpack_public_path__ + "static/img/14000644.1d111288.png";